import { stateful } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import * as m from '../../../../localization/out/messages.js';

// Final onboarding step: Confirmation + next actions
export const RegisterOnboardingFinish = stateful(() => {
  return html`
    <div class="flex flex-col items-center justify-center space-y-8 max-w-2xl mx-auto py-8">
      <!-- Success icon with animation -->
      <div class="flex justify-center">
        <div class="rounded-full bg-success/10 p-6 animate-fade-in">
          <div class="rounded-full bg-success/20 p-4">
            <div class="rounded-full bg-success p-4 shadow-lg shadow-success/30">
              <svg class="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Card with content -->
      <div class="card bg-base-100 shadow-xl w-full">
        <div class="card-body items-center text-center">
          <h2 class="card-title text-2xl font-bold mb-2">${m.register_onboarding_finish_thank_you_line1()}</h2>
          <p class="text-lg text-base-content/80 mb-6">
            ${m.register_onboarding_finish_thank_you_line2()}
          </p>
          <div class="card-actions">
            <a href="/candidate/profile" class="btn btn-primary btn-lg">
              ${m.register_onboarding_finish_to_profile_button()}
              <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <style>
      @keyframes fade-in {
        0% { opacity: 0; transform: scale(0.9); }
        100% { opacity: 1; transform: scale(1); }
      }
      .animate-fade-in {
        animation: fade-in 0.6s ease-out forwards;
      }
    </style>
  `;
});
